import React from "react";
import * as Dimmer from "../../components/dimmer";
import * as S from "./styles";

export const LoadingSimulated = () => {
  return (
    <div>
        <S.Loading>
          <Dimmer.Text width="86%" />
          <Dimmer.Text width="100%" />
          <Dimmer.Text width="40%" />
          <Dimmer.Text width="40%" />
          <Dimmer.Text width="30%" />
          <Dimmer.Text width="30%" />
          <Dimmer.Text width="100%" />
          <Dimmer.Text width="100%" />
          <Dimmer.Text width="100%" />
          <Dimmer.Text width="100%" />
          <Dimmer.Text width="86%" />
          <Dimmer.Text width="40%" />
          <Dimmer.Text width="30%" />
          <Dimmer.Text width="30%" />
          <Dimmer.Text width="30%" />
        </S.Loading>
    </div>
  );
}
